<div [class.no-pointer-events]="isLocked">
  <svg
    #svgElement
    class="interactive-diagram-svg-element"
    role="group"
    [attr.aria-label]="getDiagramLabel()"
    [attr.aria-disabled]="isLocked ? 'true' : null"
   data-ui-name="Get Diagram Label()" data-ui-component="element-render-interactive-diagram" data-testid="element-render-interactive-diagram-get-diagram-label"></svg>
</div>
<div *ngIf="isShowMessage" (click)="hideOnPageMessage()" class="dg-int-on-page-message" role="alert" aria-live="assertive" aria-atomic="true" data-ui-name="Div" data-ui-component="element-render-interactive-diagram" data-testid="element-render-interactive-diagram-div">
  <tra-md [slug]="onPageMessage" [isCondensed]="true" [isFlex]="true"></tra-md>
</div>

<!-- voiceover -->
<div *ngFor="let data of voiceoverDataList">
  <render-audio
    [url]="data.url" 
    [trigger]="data.trigger" 
    [isTriggerDisabled]="!isVoiceoverEnabled()"
   data-ui-name="Render audio" data-ui-component="element-render-interactive-diagram" data-testid="element-render-interactive-diagram-render-audio"></render-audio>
</div>
